// src/App.js
import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Movies from "./pages/Movies";
import MovieDetail from "./pages/MovieDetail";
import SeriesDetail from "./pages/SeriesDetail";
import Books from "./pages/Books";
import Comics from "./pages/Comics";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Upload from "./pages/Upload";
import Creators from "./pages/Creators";
import Profile from "./pages/Profile";
import Search from "./pages/Search";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import AIPolicy from "./pages/AIPolicy";
import DMCA from "./pages/DMCA";
import SubmissionsAdmin from "./pages/SubmissionsAdmin";
import UsersAdmin from "./pages/UsersAdmin";
import VideosAdmin from "./pages/VideosAdmin";
import { getCurrentUser, logoutUser } from "./utils/auth";

function App() {
  const [user, setUser] = useState(getCurrentUser());
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
    setUser(null);
    navigate("/login");
  };

  // Set base document title
  useEffect(() => {
    if (document.title === "React App" || document.title === "") {
      document.title = "AIVEO — AI Cinema Platform";
    }
  }, []);

  return (
    <div className="app-container">
      <Navbar user={user} onLogout={handleLogout} />
      <main className="main-content">
        <Routes>
          <Route path="/"                   element={<Home />} />
          <Route path="/movies"             element={<Movies />} />
          <Route path="/movies/:id"         element={<MovieDetail />} />
          <Route path="/series/:id"         element={<SeriesDetail user={user} />} />
          <Route path="/books"              element={<Books />} />
          <Route path="/comics"             element={<Comics />} />
          <Route path="/login"              element={<Login setUser={setUser} />} />
          <Route path="/register"           element={<Register setUser={setUser} />} />
          <Route path="/upload"             element={<Upload />} />
          <Route path="/creators"           element={<Creators />} />
          <Route path="/profile"            element={<Profile user={user} setUser={setUser} />} />
          <Route path="/search"             element={<Search />} />
          <Route path="/about"              element={<About />} />
          <Route path="/terms"              element={<Terms />} />
          <Route path="/privacy"            element={<Privacy />} />
          <Route path="/ai-policy"          element={<AIPolicy />} />
          <Route path="/dmca"               element={<DMCA />} />
          <Route path="/admin/submissions"  element={<SubmissionsAdmin />} />
          <Route path="/admin/users"        element={<UsersAdmin />} />
          <Route path="/admin/videos"       element={<VideosAdmin />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
